<template>
<div class="container pb-4">

  <div v-if="items.length == 0" class="text-center pb-3">
        <div class="card">
          <div class="card-body">
            <div>Cart is empty</div>
            <div><a class="btn btn-danger mt-3 px-3" href="/">Start shopping</a></div>
          </div>
        </div>
        </div>

    <div v-else>
    <div class="section-heading-md pt-0 pb-3 text-center">Shopping Cart</div>
    <div class="row">

      <div class="col-md-9">

        <div class="card mb-2">
        <div class="card-body pb-2">

        <!-- Desktop -->
        <table class="table">
          <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td class="text-center">
                  <a :href="`/product/${item.product.id}/${createSlug(item.product.name)}`">
                  <img v-if="item.product.images.length > 0" :src="item.product.images[0].url" style="height:4rem;" />
                  <img v-else src="/images/image-not-found.svg" style="height:4rem;" />
                  </a>
                </td>
                <td class="pl-3">
                    <div><b>{{item.product.name}}</b></div>
                    <small class="mt-1"><a href="#/" @click="removeProduct(item.product)" class="redlink"><i class="fas fa-trash"></i> Remove</a></small>
                </td>
                <td class="pl-3 pr-0">
                    <div><b>R {{item.product.price*item.quantity}}</b></div>
                    <div>
                        <select class="form-control2" v-model="item.quantity" @change="updateQuantity(item)">
                            <option v-for="(apple, index) in apples" :key="index" :value="apple">{{apple}}</option>
                        </select>
                    </div>
                </td>  
              </tr>
          </tbody>
        </table>

</div>
</div>

      </div>

      <div class="col-md-3">

          <div class="card">
            <div class="card-body">
              <div><b>Cart summary</b></div>
              <div class="row mt-2">
                <div class="col">{{itemCount}} {{word}}</div>
                <div class="col text-right">R {{totalAmount}}</div>
              </div>
              <div class="mt-3" v-if="itemCount > 0"><a href="/checkout" class="btn btn-success col"><i class="fas fa-shopping-cart"></i> Go to checkout</a></div>
            </div>
          </div>

          <div class="card mt-2">
            <div class="card-body">
              <div><small><i class="fas fa-lock" style="width: 20px;"></i> Secure checkout</small></div>
              <div class="mt-2"><small><i class="fas fa-money-check" style="width: 20px;"></i> Many ways to pay</small></div>
              <div class="mt-2"><small><i class="fas fa-truck" style="width: 20px;"></i> Fast, reliable delivery</small></div>
              <div class="mt-2"><small><i class="fas fa-undo" style="width: 20px;"></i> Easy return & refund</small></div>
            </div>
          </div>

      </div>

    </div>
</div>
</div>
</template>

<script>
import { EventBus } from '../bus';

export default {

  data() {
    return {
      items: [],
      itemCount: 0,
      totalAmount: 0,
      loading: false,
      word: 'item',
      apples: [],
    };
  },

  created() {
    this.setQuantities();
    this.getProducts();
  },

  methods: {

    setQuantities() {
      let end = 50;
      for (let i = 1; i <= end; i++) {
        this.apples.push(i);
      }
    },

    removeProduct(product) {

        Swal.fire({
        title: 'Are you sure you want to remove this product?',
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Yes, remove it',
        customClass: { title: "popup-title"},
      }).then((result) => {

      if (result.isConfirmed) {
          this.removeProductAction(product);
        } 

      })

    },

    removeProductAction(product) {
      axios
        .post('/cart/remove', {
          product_id: product.id
        })
        .then((response) => {
          this.getProducts();
          EventBus.$emit('update-cart', product);
        });
    },

    updateQuantity(item) {
      if (item.product) {
        axios
          .post('/cart/update', {
            product_id: item.product.id,
            quantity: item.quantity
          })
          .then((response) => {

            if (response.data.success) {
              this.getProducts();
              EventBus.$emit('update-cart', item.product);
            } else {
              this.sweetfire(response.data.message);
            }

          });
      }
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirmButton: false,
        cancelButtonText: "Ok",
        customClass: { title: "popup-title" },
      });
    },

    getProducts() {

      this.loading = true;

      axios
        .get('/cart/items')
        .then((response) => {
          this.items = response.data;
          this.countItems();
          this.getTotalAmount();
          this.loading = false;
        });

    },

    getTotalAmount() {
      this.totalAmount = this.items.reduce((total, item) => {
        if (!item.product) {
          return total;
        }
        return total + (item.product.price * item.quantity);

      }, 0);
    },

    updateWord() {
      this.word = (this.itemCount == 1) ? 'item' : 'items';
    },

    countItems() {
      axios
        .get('/cart/item-count')
        .then((response) => {
          this.itemCount = response.data;
          this.updateWord();
        });
    },

  },
};
</script> 
